import React, {
  forwardRef,
  useCallback,
} from 'react'

import PropTypes from 'prop-types'
import classnames from 'classnames'

import Styles from './styles.module.sass'

const DEFAULT_TYPE = 'text'

/**
 * N.B.: **This is a controlled component**: it does not maintain its own state.
 *
 * @returns {Node}
 */
export default forwardRef(Input)

function Input({ className, disabled, handleChange, handleFocus, type, ...props }, ref) {
  const inputType = type || DEFAULT_TYPE

  const onChange = useCallback((e) => {
    if ( disabled ) {
      return
    }

    e.stopPropagation()

    const {
      name,
      value,
    } = e.target

    handleChange({
      name,
      value,
    })
  }, [disabled, handleChange])

  const onFocus = useCallback((e) => {
    if ( disabled || !handleFocus ) {
      return
    }

    handleFocus()
  }, [disabled, handleFocus])

  const rootClassName = classnames(Styles.root, className)

  return (
    <input
      className={ rootClassName }
      disabled={ disabled }
      onChange={ onChange }
      onFocus={ onFocus }
      ref={ ref }
      { ...props }
      type={ inputType }
    />
  )
}

Input.propTypes = {
  handleChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,

  className: PropTypes.string,
  disabled: PropTypes.bool,
  handleFocus: PropTypes.func,
  name: PropTypes.string,
  type: PropTypes.oneOf([
    'color',
    'date',
    'datetime-local',
    'email',
    'file',
    'hidden',
    'month',
    'number',
    'password',
    'range',
    'tel',
    'text',
    'time',
    'url',
    'week',
  ]),
}
